import { fetchDadata } from '@/libs/dadata/api'
import { renderSuggestions } from '@/libs/dadata/template'
import { $ } from '@/libs/jquery/index'

interface IDadataOptionsIn {
  searchField?: JQuery,
  typeDadata?: string,
  errorCallback?(): void,
  successCallback?(suggest: IDadataResponseNode<IBank | IParty | IFmsUnit | IAddress | ICountry>): void,
}

interface IDadataOptions {
  count?: number,
  field?,
  type?: string,
  onSelect(suggest?: IDadataResponseNode): void,
  onSelectNothing(): void,
}

export class DadataLib {
  private options: IDadataOptions = {
    count: 5,
    onSelect: () => null,
    onSelectNothing: () => null,
    type: 'party',
  }
  private suggestions: IDadataResponseNode[]
  private className: string = 'form-suggestion__list'
  private selectors: ISelectors = {
    item: '[data-selector="dadataSuggestion"]',
  }
  private timeout: number = 0

  constructor(options: IDadataOptionsIn) {
    const {
      searchField,
      successCallback,
      errorCallback = () => null,
      typeDadata = 'party'} = options
    this.options.field = searchField
    this.options.onSelect = successCallback
    this.options.onSelectNothing = errorCallback
    this.options.type = typeDadata.toLowerCase()

    if (this.options.field) {
      this.init(this.options)
    }
  }

  // отправить запрос и на первый элемент вызвать success
  public fixData(count: number = 1): void {
    const value = this.options.field.val()
    if (value && value.length > 2) {
      fetchDadata(value, count, this.options.type).then((response: IDadataResponse) => {
        if (response.suggestions.length > 0) {
          this.options.onSelect(response.suggestions[0])
          this.options.field.valid()
        }
      }, () => {
        this.options.onSelectNothing()
      })
    }
  }

  private init(options: IDadataOptions): void {
    this.initListeners(options.field)
  }

  private initListeners(field: JQuery): void {
    field
      .on('input focus', (e) => this.inputHandler(e))
    $('body')
      .on('click', this.selectors.item, (e) => this.selectHandler(e))
      .on('click', (e) => this.blurHandler(e))
  }

  /**
   * На событие onInput проверяем, есть ли value и посылаем запрос
   */
  private inputHandler(e: JQuery.TriggeredEvent): void {
    if (e.target) {
      const value = e.target.value

      if (value && value.length > 2) {
        // Создаем хэндлер, который запрашивает данные,
        // но не чаще чем в X миллисекунд что бы не создавать лишней нагрузки на дом
        const handler = () => {
          if (this.timeout) {
            clearTimeout(this.timeout)
          }
          this.timeout = window.setTimeout(() => { this.fetchData(value) }, 200)
        }
        handler()
      }
    }
  }

  /**
   * На событие onClick - выбираем suggestion и посылаем onSelect
   * закрываем ноду и чистим список организаций
   */
  private selectHandler(e: JQuery.ClickEvent): void {
    e.preventDefault()
    e.stopPropagation()
    const index: number = e.currentTarget.dataset.index
    if (this.suggestions && this.suggestions[index]) {
      this.options.onSelect(this.suggestions[index])
      this.options.field.valid()
      this.suggestions = []
      this.toggleNode()
    }
  }

  // скрываем ноду, если кликнули не туда
  private blurHandler(e: JQuery.ClickEvent): void {
    if ($(e.target).siblings(`.${ this.className}`).length === 0) {
      this.suggestions = []
      this.toggleNode()
    }
  }

  /**
   * Отправляем запрос в дадату и получаем данные в виде объекта
   */
  private fetchData(query: string): void {
    fetchDadata(query, this.options.count, this.options.type).then((response: IDadataResponse) => {
      this.onSuccess(response)
    }, () => {
      this.suggestions = []
      this.toggleNode()
      this.options.onSelectNothing()
    })
  }

  // если получен ответ, то показываем список
  private onSuccess(response: IDadataResponse): void {
    let suggestions = response.suggestions
    if (this.options.type === 'party') {
      suggestions = response.suggestions.filter((suggestion: IDadataResponseNode<IParty>): boolean => {
        return suggestion.data.state.status === 'ACTIVE'
      })
      this.addSuggestionsList(suggestions)
    }
    this.addSuggestionsList(suggestions)
  }

  // добавляем список в ноду и показываем ноду
  private addSuggestionsList(suggestions: IDadataResponseNode[]): void {
    this.suggestions = suggestions
    this.toggleNode(true)
  }

  // получаем ноду - если она есть у другого поля, то удаляем и добавляем заново к правильному полю
  private getNode(): JQuery {
    let node = $(`.${ this.className}`)
    if (node.length === 0 || this.options.field.siblings(`.${ this.className}`).length === 0) {
      if (node.length > 0) {
        node.detach()
      }
      node = $(`<div class=${ this.className }></div>`)
      this.options.field.after(node)
    }

    return node
  }

  // отображаем список, скрываем ноду
  private toggleNode(isShow: boolean = false): void {
    const node: JQuery = this.getNode()
    node.html(renderSuggestions(this.suggestions, this.options.type))
    if (isShow) {
      node.show()
    } else {
      node.hide()
    }
  }
}
